module.exports = __webpack_public_path__ + "assets/img/icon7.2fd00dd4.svg";